import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { PageHeader } from '../common/PageHeader';
import { ResultSection } from '../common/sections/ResultSection';
import BrandUtils from '../../utils/BrandUtils';
import ProductUtils from '../../utils/ProductUtils';
import ContentUtils from '../../utils/ContentUtils';

function SetupInProgressPage({ content, data }) {
  return (
    <div className="internet-banking result-page-wrapper deferred-page-wrapper container-fluid">
      <Helmet title={content.setupInProgressHeader} />
      <PageHeader
        visible={BrandUtils.isAbleToDisplay('result-pages-header')}
        title={`${content.landingPageTitle}${ProductUtils.getName(
          data.productCode
        )}`}
        content={content}
      />
      <div className="result-page deferred-page" role="main">
        <div className="row text-center">
          <div className="col-xs-12">
            <ResultSection
              imgSrc={BrandUtils.getResultImage(
                'id-deferred-page-with-image',
                'bank-illustration.png'
              )}
              imgAlt="Setup in Progress"
              title={content.setupInProgressTitle}
            >
              {ContentUtils.getContentParagraphs(
                'setupInProgressText',
                content,
                ''
              )}
            </ResultSection>
          </div>
        </div>
      </div>
    </div>
  );
}

SetupInProgressPage.propTypes = {
  data: PropTypes.object,
  content: PropTypes.object,
};

export { SetupInProgressPage };
